<template>
  <div class="footer">
    <hollow_main_btn @click="$emit('cancel')">
      <slot name="cancel">
        <span class="btnText">{{ $t("common.cancel") }}</span>
      </slot>
    </hollow_main_btn>
    <main_btn :disabled="disabled" @click="$emit('next')">
      <slot name="next">
        <span class="btnText">{{ $t("common.save") }}</span>
      </slot>
    </main_btn>
  </div>
</template>
<script>
import main_btn from "~/components/shared/mainBtn"
import hollow_main_btn from "~/components/shared/hollowMainBtn"

export default {
  components: {
    main_btn,
    hollow_main_btn,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
  },
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  margin-top: 40px;
  padding: 16px 0px;
  background-color: var(--color-white);
}

.footer > div {
  margin-right: 22px;
}
.footer > div:last-child {
  margin-right: 0px;
}

div.footer.force_float {
  margin-top: 0px;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 16px;
  margin-bottom: 0px;
  justify-content: space-between;
  left: 0px;
  box-shadow: var(--shadow-sticky-bottom);
}

.largePad768plus div.footer {
  padding: 16px 40px;
}

@media screen and (min-width: 479px) {
  .footer.space_between {
    justify-content: space-between;
    margin-top: unset;
  }
}

@media screen and (max-width: 767px) {
  div.footer {
    width: 100%;
  }

  .largePad768plus div.footer {
    padding: 16px 24px;
  }
}

@media screen and (max-width: 479px) {
  div.footer {
    margin-top: 0px;
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 16px;
    margin-bottom: 0px;
    justify-content: space-between;
    left: 0px;
    box-shadow: var(--shadow-sticky-bottom);
  }

  .footer > div {
    margin-right: 0px;
  }
}
</style>
